module.exports = __webpack_public_path__ + "static/media/kloa_logo.4adc141e.png";